import type { TableProps } from "antd";
import { Col, Row, Table, Tag, Typography } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import { formatDataInYYYYMMDDFormatWithTime } from "../../../helpers/date";
import NetwalaPagination from "../Pagination/NetwalaPagination";
import { statusColors, priorityColors } from "../../../helpers/tickets";

const SupportTicketsTable: React.FC<SupportTicketsTableProp> = ({
  tickets,
  pagination,
  handlePageChange,
  handlePageSizeChange,
}) => {
  const navigate = useNavigate();

  const columns: TableProps<ITicket>["columns"] = [
    {
      title: "ID",
      dataIndex: "ticketId",
      key: "ticketId",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <Tag color={statusColors[text as keyof typeof statusColors]}>
          {text}
        </Tag>
      ),
    },
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      render: (text) => (
        <Tag color={priorityColors[text as keyof typeof priorityColors]}>
          {text}
        </Tag>
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },

    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },

    {
      title: "Created",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => (
        <span>{formatDataInYYYYMMDDFormatWithTime(new Date(text))}</span>
      ),
    },
    {
      title: "Connection Details",
      render: (record) => (
        <span>
          {record.connectionFullName} - {record.connectionPhoneNumber}
        </span>
      ),
    },
    {
      title: "Created By",
      dataIndex: "createdByName",
      key: "createdByName",
    },
    {
      title: "Assigned To",
      dataIndex: "assignedToName",
      key: "assignedToName",
      render: (text) => <span>{text ? text : "Unassigned"}</span>,
    },
  ];

  return (
    <>
      <div className="netwala-users-table-container">
        <Row>
          <Col span={24}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginRight: "5px",
              }}
            >
              <Typography className="netwala-user-tables-heading">
                Complaints
              </Typography>
              {/* <Search
                placeholder="Name / Phone / Address"
                onSearch={() => {
                  search.handleSearch(search.value);
                }}
                value={search.value}
                allowClear
                onChange={(e) => {
                  search.handleSearch(e.target.value);
                }}
                style={{ width: 300 }}
              /> */}
            </div>

            <Table
              className="netwala-users-table striped-table"
              columns={columns}
              dataSource={tickets}
              pagination={false}
              scroll={{ x: "max-content" }}
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => {
                    navigate(`/ticket-details/${record._id}`);
                  }, // click row
                };
              }}
            />
          </Col>
          <Col
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
              marginBottom: "20px",
            }}
            span={24}
          >
            <NetwalaPagination
              pagination={pagination}
              handlePageSwitch={handlePageChange}
              handlePageSizeChange={handlePageSizeChange}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};
export default SupportTicketsTable;
